import {createSlice} from '@reduxjs/toolkit';

export interface LoaderState {
    waitCount: number;
    show: boolean;
}

export const initialLoaderState: LoaderState = {
    waitCount: 0,
    show: false
};

const loaderSlice = createSlice({
    name: 'loader',
    initialState: initialLoaderState,
    reducers: {
        showLoader: (state) => {
            state.waitCount += 1;
            state.show = state.waitCount > 0;
        },
        hideLoader: (state) => {
            state.waitCount = Math.max(0, state.waitCount - 1);
            state.show = state.waitCount > 0;
        }
    }
});

export const {showLoader, hideLoader} = loaderSlice.actions;
export default loaderSlice.reducer;
